import React from 'react'
import { CartPlus, SearchIconC } from '../../Images/svgs'
import { Outlet, useParams } from 'react-router-dom';

function RencetNews() {

    const { newsId } = useParams();
    const example = 'https://www.syria.tv/sites/default/files/styles/detailed_thumb_/public/2023-09/%D8%A7%D8%B9%D8%B5%D8%A7%D8%B1-%D8%AF%D8%A7%D9%86%D9%8A%D8%A7%D9%84-%D9%84%D9%8A%D8%A8%D9%8A%D8%A7.jpg'

    return (
        <>
            {newsId ? (
                <Outlet />
            ) : (
                <div className="flex flex-col px-5 mt-20">
                    <div className="self-start text-5xl font-bold text-right whitespace-nowrap text-zinc-900">
                        أخبار الخير
                    </div >
                    <div className="flex flex-col justify-center px-6 py-7 mt-12 w-full bg-white rounded-2xl max-md:px-5 max-md:mt-10 max-md:max-w-full">
                        <div className="flex gap-5 justify-between w-full rounded-none max-md:flex-wrap max-md:max-w-full">
                            <div className="flex gap-5 justify-end my-auto text-xl font-light text-right text-black max-md:flex-wrap max-md:max-w-full">
                                <SearchIconC className="w-9 aspect-square" />
                                <input placeholder='ابحث عن مقال داخل المدونة او قم بعمل تصفية وفرز'
                                    className="grow max-md:w-[10%] my-auto outline-none text-black w-[100%]" />
                            </div>
                            <button className="justify-center px-5 py-2.5 text-base font-bold text-center text-white whitespace-nowrap bg-blue-900 rounded-lg shadow-sm aspect-[1.51]">
                                بحث
                            </button>

                        </div>
                    </div>
                    <div className="justify-end mt-11 w-full max-md:mt-10 max-md:max-w-full">
                        <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                            <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
                                <div className="flex flex-col items-center grow pt-4 pb-12 w-full text-right bg-white rounded-xl max-md:mt-5 max-md:max-w-full">
                                    <div className='rounded-lg px-4'>
                                        <img
                                            loading="lazy"
                                            srcSet={example}
                                            className=" max-w-fullobject-cover rounded-lg self-center"
                                        />
                                    </div>
                                    <div className="flex flex-col p-4 mt-6 max-md:max-w-full">
                                        <div className="text-xl font-bold text-zinc-900 max-md:max-w-full">
                                            فيضانات ليبيا مأساة تتطلب تدخلاً إنسانيًا عاجلاً
                                        </div>
                                        <div className="mt-2 text-base tracking-wide text-ellipsis text-zinc-600 max-md:max-w-full">
                                            تعيش ليبيا أوقاتًا صعبة بعد تعرضها لفيضانات وأمطار غزيرة
                                            نادرة، أسفرت عن خسائر كبيرة وفقدان العديد من الأرواح في مناطق
                                            شرق البلاد، ولا سيما في مدينة درنة.
                                            <br />
                                            ولقى أكثر من 2000 شخص مصرعهم في الكارثة بج
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                                <div className="grid grid-rows-3">
                                    <div className="row-span-2 flex flex-col justify-center gap-3 xl:mt-0 sm:mt-2">
                                        <div className="justify-end py-4 pr-2.5 pl-7 bg-white rounded-xl max-md:pl-5 max-md:mt-3 max-md:max-w-full">
                                            <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                                                <div className="flex flex-col ml-5 w-[32%] max-md:ml-0 max-md:w-full">
                                                    <img
                                                        loading="lazy"
                                                        srcSet={example}
                                                        className="self-stretch my-auto max-w-full max-md:mt-10 rounded-lg"
                                                    />
                                                </div>
                                                <div className="flex flex-col w-[68%] max-md:ml-0 max-md:w-full">
                                                    <div className="flex flex-col grow justify-between self-stretch pb-8 text-right max-md:mt-10">
                                                        <div className="text-xl font-bold text-zinc-900">
                                                            مؤسسة الخير تبدأ تدخلاً إنسانياً عاجلاً لإغاثة ضحايا
                                                            زلزال المغرب
                                                        </div>
                                                        <div style={{
                                                            width: '350px',
                                                            overflow: 'hidden',
                                                            whiteSpace: 'nowrap',
                                                            textOverflow: 'ellipsis'
                                                        }}
                                                        >
                                                            بدأت مؤسسة الخير تدخلاً إنسانياً عاجلاً لمساعدة ودعم
                                                            ضحايا زلزال المغرب، الذي ضرب جنوب غربي مراكش وخلّف مئات
                                                            الضحايا والإصابات، عدا عن الدمار الهائل.وتسعى مؤسسة
                                                            الخير لتقديم المساعدات الإغاثية المنقذة للحياة
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div className="justify-end py-4 pr-2.5 pl-7 bg-white rounded-xl max-md:pl-5 max-md:max-w-full">
                                            <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                                                <div className="flex flex-col ml-5 w-[32%] max-md:ml-0 max-md:w-full">
                                                    <img
                                                        loading="lazy"
                                                        srcSet={example}
                                                        className="self-stretch my-auto max-w-full max-md:mt-10 rounded-lg"
                                                    />
                                                </div>
                                                <div className="flex flex-col w-[68%] max-md:ml-0 max-md:w-full">
                                                    <div className="flex flex-col grow justify-between self-stretch pb-8 text-right max-md:mt-10">
                                                        <div className="text-xl font-bold text-zinc-900">
                                                            مؤسسة الخير تبدأ تدخلاً إنسانياً عاجلاً لإغاثة ضحايا
                                                            زلزال المغرب
                                                        </div>
                                                        <div style={{
                                                            width: '350px',
                                                            overflow: 'hidden',
                                                            whiteSpace: 'nowrap',
                                                            textOverflow: 'ellipsis'
                                                        }}
                                                        >
                                                            بدأت مؤسسة الخير تدخلاً إنسانياً عاجلاً لمساعدة ودعم
                                                            ضحايا زلزال المغرب، الذي ضرب جنوب غربي مراكش وخلّف مئات
                                                            الضحايا والإصابات، عدا عن الدمار الهائل.وتسعى مؤسسة
                                                            الخير لتقديم المساعدات الإغاثية المنقذة للحياة
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>
                    <div className="self-start mt-20 text-5xl font-bold text-right whitespace-nowrap text-zinc-900 max-md:mt-10">
                        حملات مختارة
                    </div>
                    <div className="mt-7 w-full max-md:max-w-full">
                        <div class="grid grid-cols-3 gap-5 max-w-[100%] max-md:flex max-md:flex-col max-md:gap-0">
                            <div className="flex flex-col ml-5 max-md:ml-0 max-md:w-full">
                                <div className="flex flex-col grow p-2 mx-auto w-full bg-white rounded-lg border border-solid border-zinc-300 max-md:mt-5">
                                    <div className="flex overflow-hidden relative flex-col justify-between px-3 pt-3 pb-12 w-full text-sm font-medium tracking-normal leading-3 text-center text-emerald-900 uppercase whitespace-nowrap rounded-md aspect-[1.85]">
                                        <img
                                            loading="lazy"
                                            srcSet={example}
                                            className="object-cover absolute inset-0 size-full"
                                        />
                                        <div className="flex relative gap-5 justify-between mb-20 max-md:mb-10">
                                            <div className="justify-center px-2.5 py-1 my-auto bg-emerald-100 rounded-xl border-emerald-900 border-solid border-[0.5px]">
                                                بيوت فقراء
                                            </div>
                                            <img
                                                loading="lazy"
                                                src={example}
                                                className="w-6 aspect-square"
                                            />

                                        </div>
                                    </div>
                                    <div className="flex flex-col p-2 mt-1">
                                        <div className="text-xl font-bold text-right text-zinc-900">
                                            صيانة آبار ومحطات تحلية مياه
                                            <br />
                                        </div>
                                        <div className="self-start mt-3 text-sm text-right whitespace-nowrap text-stone-900">
                                            آخر تبرع قبل ساعتين
                                        </div>
                                        <div className="flex flex-col justify-center items-start w-[100%]pl-16 mt-2 bg-gray-200 rounded max-md:pl-5">
                                            <div className="h-2 rounded w-[90%] bg-blue-800" />
                                        </div>
                                        <div className="flex gap-5 justify-between mt-3 text-right text-stone-900">
                                            <div className="text-base font-bold">66,200$ دولار </div>
                                            <div className="text-sm">$100,000 دولار</div>
                                        </div>
                                    </div>
                                    <div className="flex gap-2 justify-between mt-1">
                                        <div className="grow flex gap-5 justify-between p-1 whitespace-nowrap bg-white rounded-lg border border-solid border-[color:var(--Gray-300,#D0D5DD)]">
                                            <input className="my-auto text-base leading-6 text-right w-[50%] outline-none text-black indent-1"
                                                placeholder='القيمة'
                                            />
                                            <div className="justify-center px-3.5 py-2 text-sm font-semibold leading-5 text-white bg-blue-600 rounded-lg border border-blue-500 border-solid shadow-sm aspect-[1.39]">
                                                تبرع
                                            </div>

                                        </div>
                                        <div className="flex justify-center items-center px-3.5 py-3 bg-white rounded-lg border border-solid shadow-sm aspect-[1.11] border-[color:var(--Gray-300,#D0D5DD)]">
                                            <CartPlus />
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="self-start mt-20 text-5xl font-bold text-right whitespace-nowrap text-zinc-900 max-md:mt-10">
                        المزيد من الاخبار
                    </div>
                    <div className="mt-5 w-full max-md:max-w-full">
                        <div class="grid grid-cols-2 gap-5 max-w-[100%] max-md:flex max-md:flex-col max-md:gap-0">
                            <div className="flex flex-col max-md:ml-0 max-md:w-full">
                                <div className="grow p-2 w-full bg-white rounded-2xl border border-solid border-zinc-300 max-md:mt-5 max-md:max-w-full">
                                    <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                                        <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                                            <img
                                                loading="lazy"
                                                srcSet={example}
                                                className="grow w-full aspect-[1.3] max-md:mt-3 rounded-lg"
                                            />
                                        </div>
                                        <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                                            <div className="flex flex-col grow self-stretch pt-5 pb-12 w-full bg-white bg-opacity-70 max-md:mt-3">
                                                <div className="justify-center self-start px-2.5 py-1 mr-4 text-sm font-medium tracking-normal leading-3 text-center text-pink-800 uppercase whitespace-nowrap bg-red-100 rounded-xl border-pink-800 border-solid aspect-[2.61] border-[0.5px] max-md:mr-2.5">
                                                    صحة
                                                </div>
                                                <div className="flex flex-col px-4 mt-3 text-right">
                                                    <div className="text-xl font-bold text-zinc-900">
                                                        انتشال أحياء في درنة والمساعدات الدولية تتدفق على ليبيا
                                                        <br />
                                                    </div>
                                                    <div className="self-start mt-3 text-sm whitespace-nowrap text-stone-900">
                                                        18 April 2023
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex gap-2 justify-center self-center px-3.5 py-2 mt-5 text-sm font-medium leading-5 whitespace-nowrap bg-white rounded-lg border border-gray-300 border-solid shadow-sm text-neutral-900">
                        <img
                            loading="lazy"
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/3c662ea3d5d1a8c5d80c168da176217c00ea220fd13d0ef8a9d5d0ecbdb0e3de?"
                            className="w-6 aspect-square"
                        />
                        <div className="grow my-auto">تحميل المزيد</div>
                    </div>
                </div >
            )
            }

        </>
    )
}

export default RencetNews